export default __webpack_public_path__ + "static/media/im.db2830d6.jpg";